import api from '@/api.js'
var formal_examJs = {
  methods: {
    post_records_purchase (id, type) {
      // let self = this

      let path = `/gept/records/?purchase=no`

      return api.post(path, { id: id, type: type })
      .then((response) => {
        return response.data
      })
      .catch((err) => {
        return err.response.data
      })
    },
    post_gept_records_start (item) {
      // 考試開始
      let self = this
      let path = `/gept/records/?purchase=yes`
      self.$store.dispatch('isLoading', true)

      api.post(path, { id: item.id, type: item.type })
      .then((res) => {
        self.$store.dispatch('isLoading', false)
        self.$store.dispatch('getRemainPoints')
        self.$router.push({ name: 'formal_exam', params: { select_id: item.id, practice_type: item.type }, query: { record_id: res.data.record_id } })
      })
      .catch(() => {
        self.$store.dispatch('isLoading', false)
        self.$swal.fire({
          focusConfirm: false,
          confirmButtonText: `確認`,
          title: 'Notice',
          text: '發生錯誤',
          customClass: {
            title: 'text-white',
            container: '',
            popup: 'p-0',
            header: 'swal-header-notice justify-center items-center',
            closeButton: '',
            htmlContainer: 'font-semibold my-4 text-2xl',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      })
    },
    post_gept_records_byFormal (exam_id, questionId, part, text, file) {
      let self = this
      let path = `/gept/records/${exam_id}`

      self.$store.dispatch('isLoading', true)

      let formData = new FormData()
      formData.append('file', file)
      formData.append('id', questionId)
      formData.append('part', part)
      formData.append('text', text)

      return api.post(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then((response) => {
        self.$store.dispatch('isLoading', false)
        return response.data
      })
      .catch((err) => {
        self.$store.dispatch('isLoading', false)

        return err.response
      })
    },
    post_gept_records_finish (exam_id) {
      let self = this
      let attempt = 0
      let maxRetries = 10
      let retryInterval  = 10000
      let path = `/gept/records/${exam_id}/finish`

      self.$store.dispatch('isLoading', true)

      const makeRequest = () => {
        api.post(path)
          .then(() => {
            self.$store.dispatch('isLoading', false)

            self.$router.push({ name: `gept_report_formal`, params: { record_id: exam_id  } })
          })
          .catch(() => {
            attempt ++
            if (attempt < maxRetries) {
              setTimeout(makeRequest, retryInterval)
            }
          })
      }

      makeRequest()
    },

    get_gept_records (exam_id) {
      // let self = this

      let path = `/api/toeic/exams/${exam_id}/records`

      return api.get(path)
      .then((res) => {
        return res
      })
      .catch(() => {
      })
    }
  }
}

export default formal_examJs
